import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María Fernández',
  avatar: 'https://i.pravatar.cc/150?img=47',
  quote: 'Llevaba meses comiendo solo pollo hervido y verduras por miedo a empeorar mi hígado. Este recetario me devolvió la alegría de comer. Las recetas son deliciosas y en mi último chequeo mis enzimas hepáticas bajaron a niveles normales.',
  rating: 5
}, {
  name: 'Carlos Ruiz',
  avatar: 'https://i.pravatar.cc/150?img=11',
  quote: 'Lo mejor es que los ingredientes son cosas que ya tengo en casa o encuentro fácil en el súper. He perdido 6 kilos sin sentir que estoy a dieta y mi energía ha vuelto. Mi esposa también ama las recetas.',
  rating: 5
}, {
  name: 'Ana López',
  avatar: 'https://i.pravatar.cc/150?img=32',
  quote: 'El plan de 30 días me salvó. Estaba muy confundida después de mi diagnóstico, pero seguir el menú paso a paso me quitó todo el estrés. La inflamación que sentía después de comer desapareció por completo.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-205">
            Historias de éxito reales
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-206">
            Únete a miles de personas que ya están revirtiendo su hígado graso
            de forma natural con recetas deliciosas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-207">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-bg p-8 rounded-3xl relative" data-id="element-208">
              <div className="flex text-yellow-400 mb-4" data-id="element-209">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-210" />)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-211">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-212">
                <img src={testimonial.avatar} alt={`Foto de ${testimonial.name}`} className="w-12 h-12 rounded-full object-cover border-2 border-brand-accent/20" data-id="element-213" />
                <div className="font-bold text-gray-900" data-id="element-214">
                  {testimonial.name}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}